/**
 * SeriesSection - 同系列書籍區塊
 */

import { Link } from 'react-router-dom';
import type { Novel } from '../../services/types';
import { SeriesNovelCard } from './SeriesNovelCard';

export interface SeriesSectionProps {
  currentNovel: Novel;
  seriesNovels: Novel[];
}

export function SeriesSection({ currentNovel, seriesNovels }: SeriesSectionProps) {
  if (seriesNovels.length <= 1) {
    return null;
  }

  return (
    <div className="card">
      <div className="card-header flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h2 className="heading-section">同系列書籍</h2>
          <span className="body-small">
            第 {currentNovel.series_order} / {seriesNovels.length} 本
          </span>
        </div>
        <Link
          to={`/series/${currentNovel.series?.id}`}
          className="btn btn-ghost btn-sm"
        >
          查看全部
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
      <div className="card-body">
        <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-thin">
          {seriesNovels.map((n) => (
            <SeriesNovelCard
              key={n.id}
              novel={n}
              isCurrent={n.id === currentNovel.id}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
